import { Component } from '@angular/core';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { NavigationService } from 'src/app/core/navigation.service';
import { Order, OrdersService } from 'src/app/core/orders.service';
import { ERROR_ORDER_NOT_FOUND } from 'src/app/shared/constants/operationals';

@Component({
  selector: 'app-home-orders',
  templateUrl: './home-orders.component.html',
  styleUrls: ['./home-orders.component.scss'],
})
export class HomeOrdersComponent {
  is_list_running: boolean = false;
  orders?: Order[];

  constructor(
    private orders_service: OrdersService,
    private error_service: ErrorService,
    private navigation_service: NavigationService,
  ) {}

  ngOnInit(): void {
    this.listOrders();
  }

  onRefresh(): void {
    this.listOrders();
  }

  onSeeAllClick(): void {
    this.navigation_service.toOrders();
  }

  listOrders(): void {
    this.is_list_running = true;
    this.orders_service.listOrders({ cursor: null, limit: 5 }).subscribe({
      next: response => {
        this.orders = response.data.data;
        this.is_list_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        if (processed_error.code == ERROR_ORDER_NOT_FOUND) {
          this.orders = [];
        } else {
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
        this.is_list_running = false;
      },
    });
  }
}
